module.exports = require("./ar-PS.d.ts");